


























































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'MenuItems',
})
export default class MenuItems extends Vue {
  @Prop({ default: [] }) private menuList: any;

  mounted() {}
}
